import React, { ReactNode } from 'react';
import useConnector, { IConnectorHook } from 'shared/providers/connector/context/connector-hook';

const ConnectorContext = React.createContext<IConnectorHook>({} as never);

interface IProps {
  children: ReactNode;
}

export const ConnectorProvider = ({ children }: Readonly<IProps>) => {
  return <ConnectorContext.Provider value={useConnector()}>{children}</ConnectorContext.Provider>;
};

export const useConnectorContextProvider = (): IConnectorHook => React.useContext<IConnectorHook>(ConnectorContext);
